import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSearchParamsLocalStorage, setSearchParamsLocalStorage } from 'lib/storage'

import { updateFiltersAction } from './actions'
import { getFilters } from './selectors'
import type { FiltersState } from './state'
import { DEFAULT_FILTERS } from './constants'

const FiltersContext = React.createContext<{
  filters: FiltersState
  setFilters: React.Dispatch<React.SetStateAction<FiltersState>>
}>({
  filters: DEFAULT_FILTERS,
  setFilters: () => ({}),
})

interface FiltersProviderProps {
  children: React.ReactNode
}

const FiltersProvider = ({ children }: FiltersProviderProps) => {
  const initialFilters = useSelector(getFilters)
  const dispatch = useDispatch()

  const [filters, setFilters] = useState(initialFilters)

  useEffect(() => {
    dispatch(updateFiltersAction(filters))

    const currentLocalSearch = getSearchParamsLocalStorage()
    const {
      stars,
      family,
      orderBy,
      facilities,
      accommodationTypes,
      ratings,
      maxPrice,
      minPrice,
      themes,
      boards,
      paymentOptions,
      cancellationPolicies,
    } = filters
    setSearchParamsLocalStorage({
      ...currentLocalSearch,
      filters: {
        stars,
        family,
        orderBy,
        facilities,
        accommodationTypes,
        ratings,
        maxPrice,
        minPrice,
        themes,
        boards,
        paymentOptions,
        cancellationPolicies,
      },
    })
  }, [filters, dispatch])

  const value = useMemo(() => ({ filters, setFilters }), [filters, setFilters])

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
}

export { FiltersContext, FiltersProvider }
